import axios from "axios";
import api from "lib/api/api";
import {
  SET_AUDIO_QUESTIONS,
  SET_LESEN_PASSAGE,
  SET_MCQ_LOADING,
  SET_MCQ_QUESTIONS,
} from "./types";

export const fetchMcqQuestions =
  (page = 0) =>
  async (dispatch) => {
    dispatch({ type: SET_MCQ_LOADING });

    const res = await api.get(`/placement-questions/mcq?page=${page}`);

    dispatch({
      type: SET_MCQ_QUESTIONS,
      payload: res.data,
    });
  };

export const fetchLesenPassage = () => async (dispatch) => {
  dispatch({ type: SET_MCQ_LOADING });

  const res = await api.get(`/placement-questions/lesen`);

  dispatch({
    type: SET_LESEN_PASSAGE,
    payload: res.data,
  });
};

export const fetchAudioQuestions =
  (page = 0) =>
  async (dispatch) => {
    dispatch({ type: SET_MCQ_LOADING });

    const res = await api.get(`/placement-questions/audio?page=${page}`);

    dispatch({
      type: SET_AUDIO_QUESTIONS,
      payload: res.data,
    });
  };

export const uploadAudioForQuestions =
  (file, questionIds) => async (dispatch) => {
    const formData = new FormData();
    formData.append("file", file);
    questionIds.forEach((id) => formData.append("questionIds", id));

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/placement-questions/audio/upload-multiple`,
        formData
      );
      dispatch(fetchAudioQuestions()); // Refresh list after upload
    } catch (error) {
      console.error("Audio upload failed", error);
      throw error; // Let component handle error feedback
    }
  };

export const clearAudioFromQuestions = (questionIds) => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    questionIds.forEach((id) => params.append("questionIds", id));

    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/placement-questions/audio/clear`,
      {
        params,
      }
    );

    dispatch(fetchAudioQuestions());
  } catch (error) {
    console.error("Audio clear failed", error);
    throw error;
  }
};
